import { IBaseAction, ERRORS } from '../../constants';

export interface Props {
    config?: any;
    cityNames?: any;
    expand?: any;
    shouldCheck?: boolean;
    submitSave?: boolean;
    setFlightInformations?: any;
    flightInformations?: any;
    setShouldCheck?: any;
    isOpen?: boolean;
    user?: any;
    number?: any;
    setFlights?: any;
    flightRequest?: any;
    flightDetails?: any;
    setFlightRequest?: any;
    type?: any;
    setSendOtherTypes?: any;
    addFlightInformation?: any;
    submitRpl?: any;
    setConfirmedRplRequest?: any;
    setConfirmedSaveRequest?: any;
    serverErrorMessages?: any;
    deleteFlightInformationIndex?: any;
    deleteFlightInformationTwoWayIndex?: any;
    setLastFlight?: any;
    lastFlight?: any;
    setDeleteElementNumber?: any;
    setDeleteElementGoingWay?: any;
    setDeleteElementFlightId?: any;
    deleteElementGoingWay?: any;
    setAllow?: any;
    onAddTwoWayFlightInformation?: any;
    setConfirmedAddFlightInformation?: any;
    setAddingFlight?: any;
    defaultStartDate?: any;
    defaultEndDate?: any;
    airline?: any;
    serverInfoMessages?: any;
    reviewPhase?: any;
    winterRpl?: any;
    comingFlight?: any;
    goingFlight?: any;
    updateFlightRequest?: any;
    updateFlightRequestTwoWay?: any;
    currentFlight?: any;
    isLastFlight?: boolean;
    hasError?: boolean;
    hasInfo?: boolean;
    setHasError?: any;
    setHasInfo?: any;
    editMode?: boolean;
    setEditMode?: any;
    flightsLength?: number;
    setSubmitRpl?: any;
    setSubmitSave?: any;
    hasWarning?: boolean;
}

export interface ObjectType { }

export const errorMaps: ObjectType = ERRORS;

export const CHANGE_ROUTE = 'CHANGE_ROUTE';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const SET_ACCORDION = 'SET_ACCORDION';

export type Config = {
    airlines: Array<string>;
    airplaneTypes: Array<string>;
    airportLogo: string;
    airportName: string;
    airportNameLatin: string;
    counter: number;
    letterConter: number;
    requestStatus: Array<string>;
    sourceCity: string;
}

export interface Flight {
    type: string;
    airline: string;
    flightId?: string;
    uniqueId?: string;
    incoming: boolean;
    twoWay?: boolean;
    goingWay?: boolean;
    comingWay?: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    register?: string;
    airplaneType: string;
    nightStay?: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime?: Date;
    departureTime?: Date;
    multipleRoutes?: boolean;
    daysOfWeek?: number[];
    confirmed?: boolean;
    rejected?: boolean;
    offer?: boolean;
    status: string;
    newEndDate?: Date;
    newStartDate?: Date;
    newEntranceTime?: Date;
    newDepartureTime?: Date;
    monitoringNumber?: string;
    ranges?: any[];
    overnight?: boolean;
    reasonOfRejection?: any;
    reScheduled?: boolean;
}

export interface FlightRequest {
    type: string;
    summerSeason?: Boolean;
    airline?: string;
    airlineLogo?: string;
    flights: any[];
    generatedFlights?: any[];
    monitoringNumber?: string;
    status: string;
    instanceId: string;
    taskId: string;
    monitoringNumberFile?: string;
    rejectionDescription?: string;
    reasonOfRejection?: any[];
    updatedAt?: Date;
    requesterName?: string;
    id: string;
    rpl?: any;
}
export interface CityNamesType {
    value: any;
    label: any;
    type?: string;
}

export interface FlightDuration {
    airplaneType: string;
    duration: number;
}

export interface City {
    name: string;
    name_desc: string;
    alias: string;
    flightDurations: Array<FlightDuration>;
}

export interface CityListState {
    data: City[];
    total: 0;
}

export interface CitiesInfoInitialState {
    cities: Array<City>;
}

export const CITIES_INFO = 'CITIES_INFO';
export const CITIES_INFO_SUCCESS = 'CITIES_INFO_SUCCESS';
interface GetCitiesInfoAction extends IBaseAction {
    type: typeof CITIES_INFO | typeof CITIES_INFO_SUCCESS;
    payload?: {
        data: CitiesInfoInitialState;
    };
}

export interface FlightType {
    name: string;
    name_desc: string;
    alias: string;
}

export interface FlightTypeListState {
    data: FlightType[];
    total: 0;
}

export interface FlightTypesInfoInitialState {
    flightTypes: Array<string>;
}

export const FLIGHT_TYPES_INFO = 'FLIGHT_TYPES_INFO';
export const FLIGHT_TYPES_INFO_SUCCESS = 'FLIGHT_TYPES_INFO_SUCCESS';
interface GetFlightTypesInfoAction extends IBaseAction {
    type: typeof FLIGHT_TYPES_INFO | typeof FLIGHT_TYPES_INFO_SUCCESS;
    payload?: {
        data: FlightTypesInfoInitialState;
    };
}

export interface CreateFlightRequestInitialState { }
export const CREATE_FLIGHT_REQUEST = 'CREATE_FLIGHT_REQUEST';
export const CREATE_FLIGHT_REQUEST_SUCCESS = 'CREATE_FLIGHT_REQUEST_SUCCESS';
export const CREATE_FLIGHT_REQUEST_FAILURE = 'CREATE_FLIGHT_REQUEST_FAILURE';
export const CREATE_FLIGHT_REQUEST_CLEAR = 'CREATE_FLIGHT_REQUEST_CLEAR';

export interface CreateFlightRequestAction extends IBaseAction {
    type:
    | typeof CREATE_FLIGHT_REQUEST
    | typeof CREATE_FLIGHT_REQUEST_SUCCESS
    | typeof CREATE_FLIGHT_REQUEST_FAILURE
    | typeof CREATE_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: CreateFlightRequestInitialState;
    };
}

export interface Range {
    startDate: Date;
    endDate: Date;
    departureTime: Date;
    entranceTime: Date;
    difference: number;
    result: boolean;
}

interface Success {
    flightRequest: FlightRequest;
    flights: Array<Flight>;
    hasDuplicateFlightNumber: boolean;
    ranges?: Array<Range>;
    timeIsChanged: boolean;
    result: boolean;
}

interface Error {
    airline: string;
    type: string;
    flights: Array<any>;
    taskId: string;
    instanceId: string;
    timeIsChanged: boolean;
    errorByRules: boolean;
}
export interface FlightRequestInitialState {
    success: Success;
    error: Error;
}
export const REVIEW_FLIGHT_REQUEST = 'REVIEW_FLIGHT_REQUEST';
export const REVIEW_FLIGHT_REQUEST_SUCCESS = 'REVIEW_FLIGHT_REQUEST_SUCCESS';
export const REVIEW_FLIGHT_REQUEST_FAILURE = 'REVIEW_FLIGHT_REQUEST_FAILURE';
export const REVIEW_FLIGHT_REQUEST_CLEAR = 'REVIEW_FLIGHT_REQUEST_CLEAR';
export interface ReviewFlightRequestAction extends IBaseAction {
    type:
    | typeof REVIEW_FLIGHT_REQUEST
    | typeof REVIEW_FLIGHT_REQUEST_SUCCESS
    | typeof REVIEW_FLIGHT_REQUEST_FAILURE
    | typeof REVIEW_FLIGHT_REQUEST_CLEAR;
    payload: {
        data: FlightRequestInitialState;
    };
}

export interface ConfirmMonitoring {
    instanceId: string;
    taskId: string;
    monitoringNumberFile: string;
}

export interface ConfirmMonitoringListState {
    data: ConfirmMonitoring;
}

export interface ConfirmMonitoringInfoInitialState {
    confirmMonitoring: Array<ConfirmMonitoring>;
}

export const CONFIRM_MONITORING_NUMBER = 'CONFIRM_MONITORING_NUMBER';
export const CONFIRM_MONITORING_NUMBER_SUCCESS = 'CONFIRM_MONITORING_NUMBER_SUCCESS';
export const CONFIRM_MONITORING_NUMBER_FAILURE = 'CONFIRM_MONITORING_NUMBER_FAILURE';
export const CONFIRM_MONITORING_NUMBER_CLEAR = 'CONFIRM_MONITORING_NUMBER_CLEAR';
interface ConfirmMonitoringAction extends IBaseAction {
    type:
    | typeof CONFIRM_MONITORING_NUMBER
    | typeof CONFIRM_MONITORING_NUMBER_SUCCESS
    | typeof CONFIRM_MONITORING_NUMBER_FAILURE
    | typeof CONFIRM_MONITORING_NUMBER_CLEAR;
    payload?: {
        data: ConfirmMonitoringInfoInitialState;
    };
}

//********************************/
export const UPDATE_MONITORING_FILE = 'UPDATE_MONITORING_FILE';
export const UPDATE_MONITORING_FILE_SUCCESS = 'UPDATE_MONITORING_FILE_SUCCESS';
export const UPDATE_MONITORING_FILE_FAILURE = 'UPDATE_MONITORING_FILE_FAILURE';
interface UpdateMonitoringFile extends IBaseAction {
    type: typeof UPDATE_MONITORING_FILE | typeof UPDATE_MONITORING_FILE_SUCCESS | typeof UPDATE_MONITORING_FILE_FAILURE;
    payload: {
        error?: string;
        data?: string;
    };
}
//********************************/

export const EMPTY_FIELDS = 'EMPTY_FIELDS';
export const FIRST_CONFIRM_MONITORING = 'FIRST_CONFIRM_MONITORING';
export const CONFIRMED_MONITORING = 'CONFIRMED_MONITORING';
export const FLIGHT_REQUEST_CREATED = 'FLIGHT_REQUEST_CREATED';

export interface FlightInfo {
    AirlineLatinName: string;
    AirlinePersianName: string;
    AirlineICAOCode: string;
    IsInternational: string;
    FlightNumber: string;
    SourceAirport: string;
    SourceAirportLatin: string;
    SourceAirportIATACode: string;
    DestinationAirPort: string;
    DestinationAirPortLatin: string;
    DestinationAirPortIATACode: string;
    DepartureDateTime: string;
    Message: string;
    Refrence: string;
    PermissionTypeName: string;
}

export interface FlightInfoInitialState {
    flightInfo: Array<FlightInfo>;
}
export const GET_FLIGHT_INFO = 'GET_FLIGHT_INFO';
export const GET_FLIGHT_INFO_TEST = 'GET_FLIGHT_INFO_TEST';
export const GET_FLIGHT_INFO_TEST_SUCCESS = 'GET_FLIGHT_INFO_TEST_SUCCESS';
export const GET_FLIGHT_INFO_SUCCESS = 'GET_FLIGHT_INFO_SUCCESS';
export const GET_FLIGHT_INFO_CLEAR = 'GET_FLIGHT_INFO_CLEAR';
export const GET_FLIGHT_INFO_FAILURE = 'GET_FLIGHT_INFO_FAILURE';
interface GetFlightInfoList extends IBaseAction {
    type: typeof GET_FLIGHT_INFO | typeof GET_FLIGHT_INFO_TEST | typeof GET_FLIGHT_INFO_TEST_SUCCESS | typeof GET_FLIGHT_INFO_SUCCESS | typeof GET_FLIGHT_INFO_FAILURE | typeof GET_FLIGHT_INFO_CLEAR;
    payload: {
        data: FlightInfoInitialState;
    };
    requestPayload?: any
}

export type FlightRequestActionTypes =
    | GetCitiesInfoAction
    | CreateFlightRequestAction
    | ReviewFlightRequestAction
    | ConfirmMonitoringAction
    | GetFlightTypesInfoAction
    | GetFlightInfoList
    | UpdateMonitoringFile;
